import { PhoneLarge } from 'easyship-components/icons';
import { FormattedMessage } from 'react-intl';

import { LocaleSelector } from '@/components/LocaleSelector';
import { usePaymentIntentContext } from '@/providers/PaymentIntentProvider/context';

export const OrderDetails = () => {
  const {
    data: {
      easyship_shipment_id,
      order_number,
      shipment_items,
      total_customs_value,
      destination_address: {
        name,
        phone_number,
        address_line_1,
        address_line_2,
        address_line_3,
        city,
        state,
        postal_code,
        country_simplified_name,
      },
    },
  } = usePaymentIntentContext();

  return (
    <div className="text-base font-normal">
      <div className="py-2 px-5 border-b border-sky-300 w-full flex justify-between items-center">
        <h4 className="m-0 leading-[150%] text-ink-900 font-bold">
          <FormattedMessage id="order-details.title" />
        </h4>
        <div className="px-5 pt-3">
          <LocaleSelector />
        </div>
      </div>

      <div className="py-2 px-5 border-b border-sky-300 grid grid-cols-1 md:grid-cols-[238px_1fr] gap-2 w-full">
        <div className="flex flex-col gap-2">
          <div className="flex items-start gap-1">
            <span className="min-w-20 text-ink-500">
              <FormattedMessage id="order-details.order-no" />:
            </span>
            <span>{order_number || easyship_shipment_id}</span>
          </div>
          <div className="flex items-start gap-1">
            <span className="min-w-20 text-ink-500">
              <FormattedMessage id="order-details.items" />:
            </span>
            <div className="flex flex-col gap-1">
              {shipment_items.map(({ description, quantity }, index) => (
                <span key={`${description}-${index}`}>
                  {description} x {quantity}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <div className="flex items-start gap-1">
            <span className="min-w-20 text-ink-500">
              <FormattedMessage id="order-details.ship-to" />:
            </span>
            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-1">
                <span>{name}</span>
                <PhoneLarge className="text-ink-100 size-4" />
                <span>{phone_number}</span>
              </div>
              <div className="flex flex-col">
                <span>{address_line_1}</span>
                {address_line_2 && <span>{address_line_2}</span>}
                {address_line_3 && <span>{address_line_3}</span>}
                <span>
                  {city}, {state}
                </span>
              </div>
              <span>
                {postal_code} {country_simplified_name}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="py-4 px-5 border-b border-sky-300 w-full">
        <div className="flex justify-between items-center">
          <span className="text-black">
            <FormattedMessage id="order-details.total-shipment-value" />
          </span>
          <span className="text-ink-500">{total_customs_value}</span>
        </div>
      </div>
    </div>
  );
};
